<div class="row">
  <div class="col s6 m4 l3 xl3" *ngFor="let video of videos" style="height: 460px">
    <mat-card>
      <!--<mat-card-header>
        <mat-card-title> Proceso: {{video.ProcesoCod}}</mat-card-title>
        <mat-card-subtitle>Fecha: {{video.FechaGrabacion | date:"yyyy/MM/dd"}}</mat-card-subtitle>
      </mat-card-header>-->
      <p style="font-size: 14px;padding-bottom: 5px;">
        Identificación: <strong>{{video.ProcesoCod}}</strong>
      </p>
      <a *ngIf=" video.NroReproducciones < video.ReproduccionesMax " target="_blank" routerLink='/share/{{video.Token}}' matTooltip="Reproducir video">
        <img mat-card-image
             src="{{urlApi}}/api/Portal/Grabaciones/Thumbnail?VideoName={{video.NombreArchivo}}"
             alt="Photo of CTLogPanel">
      </a>
      <a *ngIf=" video.NroReproducciones >= video.ReproduccionesMax " matTooltip="Maxìmo de reproducciones alcanzadas">
        <img mat-card-image
             src="{{urlApi}}/api/Portal/Grabaciones/Thumbnail?VideoName={{video.NombreArchivo}}"
             alt="Photo of CTLogPanel">
      </a>
      <mat-card-content>
        <div class="row" style="margin-bottom: 0;">
          <div class="col s6" style="padding: 0;">
            <p>
              Fecha: <strong>{{video.FechaGrabacion | date:"yyyy/MM/dd"}}</strong>
            </p>
          </div>
          <div class="col s6" style="padding: 0;">
            <p>
              Hora: <strong>{{getHour(video.HoraGrabacion)}}</strong>
            </p>
          </div>
          <div class="col s6" style="padding: 0;">
            <p>
              Reproducciones: <strong>{{video.NroReproducciones}}</strong>
             - <strong>{{video.ReproduccionesMax}}</strong>
            </p>
          </div>
          <div *ngIf=" video.NroReproducciones >= video.ReproduccionesMax" class="col s6" style="padding: 0; color: red">
            <p>
             <strong> Nro Reproducciones alcanzadas</strong>
            </p>
          </div>
        </div>
        <p style="margin-top: 0;">
          <strong>
            {{video.JuzgadoNombre}}
          </strong>
        </p>
        <p style="margin-top: 0;">
          <strong>
            {{video.EtiquetasLista!='NULL'?video.EtiquetasLista:''}}
          </strong>
        </p>
      </mat-card-content>
      <mat-card-actions>
        <a *ngIf="video.DescargarVideo"
          mat-button color="primary"
           matTooltip="Descargar"
           href="{{urlApi}}/api/filevideo/descargarArchivo?videoName={{video.NombreArchivo}}&token={{video.Token}}"
           download target="_blank">
          <mat-icon>get_app</mat-icon>
        </a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>

